/* tslint:disable */
/**
 * Typescript Version: TS4 for Angular
 * Application: seatback adplacer
 * Version: 0.0.17 (bpr-4)
 * Created: 2026-02-13T10:56:42.805Z
 * At: "ai-services.seatback.de"
 */
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import type { SbLocalDateTime, SbDateTime, SbLocalDate, SbLocalTime } from './api-date-time';
import type { Resolution } from './api-resolution';
import type { GeoJSON, GeometryCollection, LineString, MultiLineString, MultiPoint, MultiPolygon, Polygon, Point } from 'geojson';
import type { BigNumber } from 'bignumber.js';
import { AiAPIService } from './aiApi.service';

export enum Mode {
  Entity = 'Entity',
  Definition = 'Definition',
  URL = 'URL',
}
@Injectable()
export class AiAPI {
  public GET(url: string, pagination?: BehaviorSubject<Pagination> | null): Observable<any> {
    return this.api.GET(url, pagination);
  }

  public POST(url: string, body?: any): Observable<any> {
    return this.api.POST(url, body);
  }

  public PUT(url: string, body?: any): Observable<any> {
    return this.api.PUT(url, body);
  }

  public DELETE(url: string, body?: any): Observable<any> {
    return this.api.DELETE(url, body);
  }
  public copy(from: any, to: any): void {
    if (from != null && to != null) {
      let type = from._type ? from._type : to._type;
      let properties = null;
      if (type != null) {
        let obj = this.createDTO(type);
        if (obj != null) properties = obj._properties;
      }
      if (properties != null) {
        for (let property of properties) {
          to[property] = from[property];
        }
      } else {
        for (let key in from) {
          to[key] = from[key];
        }
      }
    }
  }
  // Methods implemented by de.bpr_systems.web.api.rest.API:

  public de_bpr_systems_web_api_rest_API_apiDocV2(mode: Mode = Mode.Entity): Observable<string> {
    let url = '/API/OpenAPI/V2.json';
    return <Observable<string>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_application(mode: Mode = Mode.Entity): Observable<string> {
    let url = '/API/Application';
    return <Observable<string>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_changelog(mode: Mode = Mode.Entity): Observable<string[]> {
    let url = '/API/Changelog';
    return <Observable<string[]>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_copyright(mode: Mode = Mode.Entity): Observable<Response> {
    let url = '/API/Copyright';
    return <Observable<Response>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_environment(mode: Mode = Mode.Entity): Observable<string> {
    let url = '/API/Environment';
    return <Observable<string>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_javaShortened(shorten: string, mode: Mode = Mode.Entity): Observable<Response> {
    let url = '/API/JAVA/' + encodeURIComponent(shorten) + '';
    return <Observable<Response>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_javaShortenedList(
    options: { shorten?: string[] } = {},
    mode: Mode = Mode.Entity
  ): Observable<Response> {
    if (!options) options = {};
    let url = '/API/JAVA?' + (options.shorten != null ? '' + this.api.queryParamArrayPrepare('shorten', options.shorten) : '') + '';
    return <Observable<Response>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_jwtPublicKey(mode: Mode = Mode.Entity): Observable<string> {
    let url = '/API/JWT/public.key';
    return <Observable<string>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_online(mode: Mode = Mode.Entity): Observable<boolean> {
    let url = '/API/Online';
    return <Observable<boolean>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_raiseError(options: { wrap?: boolean } = {}, mode: Mode = Mode.Entity): Observable<boolean> {
    if (!options) options = {};
    let url = '/API/RaiseError?' + (options.wrap != null ? '&wrap=' + options.wrap : '') + '';
    return <Observable<boolean>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_raiseErrorWithStatusCode(statusCode: number, mode: Mode = Mode.Entity): Observable<boolean> {
    let url = '/API/RaiseError/' + statusCode + '';
    return <Observable<boolean>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_ResolveError(error: string, mode: Mode = Mode.Entity): Observable<ResolvedErrorDTO> {
    let url = '/API/ResolveError/' + encodeURIComponent(error) + '';
    return <Observable<ResolvedErrorDTO>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.POST }))
        : this.api.POST(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_typescriptShortened(
    shorten: string,
    options: { tsVersion?: string; codeStyle?: CodeStyle } = {},
    mode: Mode = Mode.Entity
  ): Observable<void> {
    if (!options) options = {};
    let url =
      '/API/TS/' +
      encodeURIComponent(shorten) +
      '?' +
      (options.tsVersion != null ? '&tsVersion=' + options.tsVersion : '') +
      '' +
      (options.codeStyle != null ? '&codeStyle=' + options.codeStyle : '') +
      '';
    return <Observable<void>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_typescriptShortenedList(
    options: { shorten?: string[]; tsVersion?: string; codeStyle?: CodeStyle } = {},
    mode: Mode = Mode.Entity
  ): Observable<void> {
    if (!options) options = {};
    let url =
      '/API/TS?' +
      (options.shorten != null ? '' + this.api.queryParamArrayPrepare('shorten', options.shorten) : '') +
      '' +
      (options.tsVersion != null ? '&tsVersion=' + options.tsVersion : '') +
      '' +
      (options.codeStyle != null ? '&codeStyle=' + options.codeStyle : '') +
      '';
    return <Observable<void>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_uptime(mode: Mode = Mode.Entity): Observable<number> {
    let url = '/API/Uptime';
    return <Observable<number>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_API_version(mode: Mode = Mode.Entity): Observable<string> {
    let url = '/API/Version';
    return <Observable<string>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  } // Methods implemented by de.bpr_systems.web.api.rest.Authentication:

  public de_bpr_systems_web_api_rest_Authentication_executeIDPLoginWithCode(
    idp_option_id: string,
    options: { code?: string; redirectURL?: string } = {},
    mode: Mode = Mode.Entity
  ): Observable<Serializable> {
    if (!options) options = {};
    let url =
      '/Authentication/IDP/' +
      encodeURIComponent(idp_option_id) +
      '/Login/Code?' +
      (options.code != null ? '&code=' + options.code : '') +
      '' +
      (options.redirectURL != null ? '&redirectURL=' + options.redirectURL : '') +
      '';
    return <Observable<Serializable>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_Authentication_executeNativeLogin(
    credentials_option_id: string,
    credentialsDTO: CredentialsDTO,
    mode: Mode = Mode.Entity
  ): Observable<Serializable> {
    let url = '/Authentication/Credentials/' + encodeURIComponent(credentials_option_id) + '/Login';
    return <Observable<Serializable>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.POST }))
        : this.api.POST(url, credentialsDTO))
    );
  }
  public de_bpr_systems_web_api_rest_Authentication_retrieveAllowedOptions(
    mode: Mode = Mode.Entity
  ): Observable<AuthenticationOptionDTO[]> {
    let url = '/Authentication/Option';
    return <Observable<AuthenticationOptionDTO[]>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_Authentication_retrieveIDPLoginUrl(
    idp_option_id: string,
    options: { no_redirect?: boolean; redirectURL?: string } = {},
    mode: Mode = Mode.Entity
  ): Observable<string> {
    if (!options) options = {};
    let url =
      '/Authentication/IDP/' +
      encodeURIComponent(idp_option_id) +
      '/Login?' +
      (options.no_redirect != null ? '&no_redirect=' + options.no_redirect : '') +
      '' +
      (options.redirectURL != null ? '&redirectURL=' + options.redirectURL : '') +
      '';
    return <Observable<string>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  } // Methods implemented by de.bpr_systems.web.api.rest.Authorization:

  public de_bpr_systems_web_api_rest_Authorization_refresh(string?: string, mode: Mode = Mode.Entity): Observable<string> {
    let url = '/Authorization/Refresh';
    return <Observable<string>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.POST }))
        : this.api.POST(url, string))
    );
  } // Methods implemented by de.bpr_systems.web.api.rest.Testing:

  public de_bpr_systems_web_api_rest_Testing_datatype_dateTime(dateTime: SbDateTime, mode: Mode = Mode.Entity): Observable<SbDateTime> {
    let url = '/API/Testing/Datatype/DateTime';
    return <Observable<SbDateTime>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_Testing_datatype_localDate(localDate: SbLocalDate, mode: Mode = Mode.Entity): Observable<SbLocalDate> {
    let url = '/API/Testing/Datatype/LocalDate';
    return <Observable<SbLocalDate>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_Testing_datatype_localDateTime(
    localDateTime: SbLocalDateTime,
    mode: Mode = Mode.Entity
  ): Observable<SbLocalDateTime> {
    let url = '/API/Testing/Datatype/LocalDateTime';
    return <Observable<SbLocalDateTime>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_Testing_datatype_localTime(localTime: SbLocalTime, mode: Mode = Mode.Entity): Observable<SbLocalTime> {
    let url = '/API/Testing/Datatype/LocalTime';
    return <Observable<SbLocalTime>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public de_bpr_systems_web_api_rest_Testing_initAuthentication(mode: Mode = Mode.Entity): Observable<boolean> {
    let url = '/API/Testing/Authentication/Init';
    return <Observable<boolean>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  } // Methods implemented by de.seatback.rudimentary_client.api.ApiServlet:
  // Methods implemented by de.seatback.rudimentary_client.api.Authenticate:

  public Authenticate_login(token: string, mode: Mode = Mode.Entity): Observable<boolean> {
    let url = '/Authenticate/Login/' + encodeURIComponent(token) + '';
    return <Observable<boolean>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.POST }))
        : this.api.POST(url))
    );
  } // Methods implemented by de.seatback.rudimentary_client.api.ChatEndpoint:

  public ChatEndpoint_askAdplacer(baseChatDTO: BaseChatDTO, mode: Mode = Mode.Entity): Observable<ChatDTO> {
    let url = '/Chat/Ask';
    return <Observable<ChatDTO>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.POST }))
        : this.api.POST(url, baseChatDTO))
    );
  }
  public ChatEndpoint_deleteHistory(mode: Mode = Mode.Entity): Observable<Result> {
    let url = '/Chat/History';
    return <Observable<Result>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.DELETE }))
        : this.api.DELETE(url))
    );
  }
  public ChatEndpoint_getHistory(long: number, integer: number, binteger: number, mode: Mode = Mode.Entity): Observable<Result> {
    let url = '/Chat/History';
    return <Observable<Result>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public ChatEndpoint_getUserStatus(mode: Mode = Mode.Entity): Observable<Result> {
    let url = '/Chat/Status';
    return <Observable<Result>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  public ChatEndpoint_navigation(baseChatDTO: BaseChatDTO, mode: Mode = Mode.Entity): Observable<Result> {
    let url = '/Chat/Navigation';
    return <Observable<Result>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.POST }))
        : this.api.POST(url, baseChatDTO))
    );
  }
  public ChatEndpoint_stream(baseChatDTO: BaseChatDTO, mode: Mode = Mode.Entity): Observable<Flux> {
    let url = '/Chat/Stream';
    return <Observable<Flux>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.POST }))
        : this.api.POST(url, baseChatDTO))
    );
  }
  public ChatEndpoint_testChat(stringa: string, stringb: string, stringc: string, mode: Mode = Mode.Entity): Observable<Result> {
    let url = '/Chat/Test';
    return <Observable<Result>>(
      (mode === Mode.URL || mode === Mode.Definition
        ? new Observable<any>(o => o.next(Mode.URL ? url : { url: url, method: this.GET }))
        : this.api.GET(url))
    );
  }
  constructor(private api: AiAPIService) {
    api.api = this;
  }
  createDTO(name: any): any {
    let t = null;
    if (name == null) t = null;
    else if (name === 'Response') {
      t = new Response();
    } else if (name === 'BaseChatDTO') {
      t = new BaseChatDTO();
    } else if (name === 'ResolvedErrorDTO') {
      t = new ResolvedErrorDTO();
    } else if (name === 'Comparator') {
      t = new Comparator();
    } else if (name === 'IdentifierDTO') {
      t = new IdentifierDTO();
    } else if (name === 'IdentityDTO') {
      t = new IdentityDTO();
    } else if (name === 'NamedIdentityDTO') {
      t = new NamedIdentityDTO();
    } else if (name === 'AuthenticationOptionDTO') {
      t = new AuthenticationOptionDTO();
    } else if (name === 'AdplacerLoginDTO') {
      t = new AdplacerLoginDTO();
    } else if (name === 'Serializable') {
      t = new Serializable();
    } else if (name === 'DisplayableValueDTO') {
      t = new DisplayableValueDTO();
    } else if (name === 'ChatDTO') {
      t = new ChatDTO();
    } else if (name === 'CredentialsDTO') {
      t = new CredentialsDTO();
    } else if (name === 'Flux') {
      t = new Flux();
    } else if (name === 'FieldReference') {
      t = new FieldReference();
    } else if (name === 'IdentityWithCreatorDTO') {
      t = new IdentityWithCreatorDTO();
    } else if (name === 'ModifiableIdentityWithCreatorDTO') {
      t = new ModifiableIdentityWithCreatorDTO();
    } else if (name === 'CoordinateClusterDTO') {
      t = new CoordinateClusterDTO();
    } else if (name === 'FreeTextFieldReference') {
      t = new FreeTextFieldReference();
    } else if (name === 'NamedIdentityWithCreatorDTO') {
      t = new NamedIdentityWithCreatorDTO();
    } else if (name === 'ModifiableNamedIdentityWithCreatorDTO') {
      t = new ModifiableNamedIdentityWithCreatorDTO();
    } else if (name === 'Result') {
      t = new Result();
    } else if (name === 'IdentityArrayDTO') {
      t = new IdentityArrayDTO();
    } else if (name === 'EndpointStatisticsDTO') {
      t = new EndpointStatisticsDTO();
    } else if (name === 'NamedIdentityWithIdentifierAndCreatorDTO') {
      t = new NamedIdentityWithIdentifierAndCreatorDTO();
    } else if (name === 'EndpointDescriptorDTO') {
      t = new EndpointDescriptorDTO();
    } else if (name === 'Result') {
      t = new Result();
    } else if (name === 'MultipartFormDataInput') {
      t = new MultipartFormDataInput();
    } else if (name === 'ModifiableNamedIdentityWithIdentifierAndCreatorDTO') {
      t = new ModifiableNamedIdentityWithIdentifierAndCreatorDTO();
    } else if (name === 'NamedIdentityWithIdentifierDTO') {
      t = new NamedIdentityWithIdentifierDTO();
    } else if (name === 'RangeFieldReference') {
      t = new RangeFieldReference();
    } else if (name === 'SelectionFieldReference') {
      t = new SelectionFieldReference();
    }
    if (t != null) this.initDTO(t);
    return t;
  }

  initDTO(dto: unknown) {
    try {
      const casted: { _properties: string[] } = <{ _properties: string[] }>dto;
      if (casted._properties) {
        for (let prop of casted._properties) {
          if (!(prop in casted)) {
            Object.assign(casted, JSON.parse('{' + prop + ': null}'));
          }
        }
      }
    } catch (e) {}
  }
}
function _window(): any {
  // return the global native browser window object
  return window;
}
export class DTO {
  _checkOwner?: any;
  _type?: string = 'DTO';
  toString(): string {
    return encodeURI(JSON.stringify(this));
  }
  static get _properties(): string[] {
    return ['_checkOwner', '_type'];
  }
}

export class Pagination {
  page: number | null = null;
  pages: number | null = null;
  count: number | null = null;
  resultcount: number | null = null;
  static get _properties(): string[] {
    return ['page', 'pages', 'count', 'resultcount'];
  }
}

export class Response {}
export class BaseChatDTO {}
export class ResolvedErrorDTO extends DTO {
  status: number | null = null;
  errorCode: string | null = null;
  errorId: number | null = null;
  occured: SbDateTime | null = null;
  method: string | null = null;
  url: string | null = null;
  application: string | null = null;
  version: string | null = null;
  file: string | null = null;
  line: number | null = null;
  message: string | null = null;
  stackTrace: string[] | null = null;
  static override get _properties(): string[] {
    return [
      'status',
      'errorCode',
      'errorId',
      'occured',
      'method',
      'url',
      'application',
      'version',
      'file',
      'line',
      'message',
      'stackTrace',
      '_checkOwner',
      '_type',
    ];
  }
}
export class Comparator {}
export class IdentifierDTO extends DTO {
  readonly identifier: string | null = null;
  static override get _properties(): string[] {
    return ['identifier', '_checkOwner', '_type'];
  }
}
export class IdentityDTO extends DTO {
  id: any | null = null;
  static override get _properties(): string[] {
    return ['id', '_checkOwner', '_type'];
  }
}
export class NamedIdentityDTO extends IdentityDTO {
  name: string | null = null;
  static override get _properties(): string[] {
    return ['name', 'id', '_checkOwner', '_type'];
  }
}
export class AuthenticationOptionDTO extends NamedIdentityDTO {
  type: AuthenticationType | null = null;
  description: string | null = null;
  logoUrl: string | null = null;
  authUrl: string | null = null;
  static override get _properties(): string[] {
    return ['type', 'description', 'logoUrl', 'authUrl', 'name', 'id', '_checkOwner', '_type'];
  }
}
export class AdplacerLoginDTO extends DTO {
  adplacerApiPath: string | null = null;
  token: string | null = null;
  static override get _properties(): string[] {
    return ['adplacerApiPath', 'token', '_checkOwner', '_type'];
  }
}
export class Serializable {}
export class DisplayableValueDTO extends DTO {
  display: Serializable | null = null;
  value: Serializable | null = null;
  static override get _properties(): string[] {
    return ['display', 'value', '_checkOwner', '_type'];
  }
}
export class ChatDTO extends BaseChatDTO {}
export class CredentialsDTO extends DTO {
  username: string | null = null;
  password: string | null = null;
  static override get _properties(): string[] {
    return ['username', 'password', '_checkOwner', '_type'];
  }
}
export class Flux {}
export class FieldReference extends DTO {
  type: string | null = null;
  requires: string[] | null = null;
  order: number | null = null;
  static override get _properties(): string[] {
    return ['type', 'requires', 'order', '_checkOwner', '_type'];
  }
}
export class IdentityWithCreatorDTO extends IdentityDTO {
  readonly createdAt: SbDateTime | null = null;
  readonly createdBy: NamedIdentityDTO | null = null;
  static override get _properties(): string[] {
    return ['createdAt', 'createdBy', 'id', '_checkOwner', '_type'];
  }
}
export class ModifiableIdentityWithCreatorDTO extends IdentityWithCreatorDTO {
  readonly modifiedAt: SbDateTime | null = null;
  readonly modifiedBy: NamedIdentityDTO | null = null;
  static override get _properties(): string[] {
    return ['modifiedAt', 'modifiedBy', 'createdAt', 'createdBy', 'id', '_checkOwner', '_type'];
  }
}
export class CoordinateClusterDTO extends DTO {
  center: Point | null = null;
  radius: number | null = null;
  size: number | null = null;
  hull: Point[] | null = null;
  static override get _properties(): string[] {
    return ['center', 'radius', 'size', 'hull', '_checkOwner', '_type'];
  }
}
export class FreeTextFieldReference extends FieldReference {
  values: any[] | null = null;
  autocomplete: string | null = null;
  static override get _properties(): string[] {
    return ['values', 'autocomplete', 'type', 'requires', 'order', '_checkOwner', '_type'];
  }
}
export class NamedIdentityWithCreatorDTO extends NamedIdentityDTO {
  readonly createdAt: SbDateTime | null = null;
  readonly createdBy: NamedIdentityDTO | null = null;
  static override get _properties(): string[] {
    return ['createdAt', 'createdBy', 'name', 'id', '_checkOwner', '_type'];
  }
}
export class ModifiableNamedIdentityWithCreatorDTO extends NamedIdentityWithCreatorDTO {
  readonly modifiedAt: SbDateTime | null = null;
  readonly modifiedBy: NamedIdentityDTO | null = null;
  static override get _properties(): string[] {
    return ['modifiedAt', 'modifiedBy', 'createdAt', 'createdBy', 'name', 'id', '_checkOwner', '_type'];
  }
}
export class IdentityArrayDTO extends DTO {
  ids: any[] | null = null;
  static override get _properties(): string[] {
    return ['ids', '_checkOwner', '_type'];
  }
}
export enum CodeStyle {
  Vanilla = 'Vanilla',
  Barebone = 'Barebone',
  Angular = 'Angular',
}
export class EndpointStatisticsDTO extends DTO {
  resourceDescriptor: EndpointDescriptorDTO | null = null;
  endpointCalls: number | null = null;
  minExecutionTime: number | null = null;
  avgExecutionTime: number | null = null;
  maxExecutionTime: number | null = null;
  firstStarted: SbDateTime | null = null;
  firstFinished: SbDateTime | null = null;
  lastStarted: SbDateTime | null = null;
  lastFinished: SbDateTime | null = null;
  static override get _properties(): string[] {
    return [
      'resourceDescriptor',
      'endpointCalls',
      'minExecutionTime',
      'avgExecutionTime',
      'maxExecutionTime',
      'firstStarted',
      'firstFinished',
      'lastStarted',
      'lastFinished',
      '_checkOwner',
      '_type',
    ];
  }
}
export class NamedIdentityWithIdentifierAndCreatorDTO extends NamedIdentityWithCreatorDTO {
  identifier: string | null = null;
  static override get _properties(): string[] {
    return ['identifier', 'createdAt', 'createdBy', 'name', 'id', '_checkOwner', '_type'];
  }
}
export enum AuthenticationType {
  NATIVE = 'NATIVE',
  CREDENTIALS = 'CREDENTIALS',
  IDP = 'IDP',
  API_KEY = 'API_KEY',
  CERTIFICATE = 'CERTIFICATE',
}
export class EndpointDescriptorDTO extends DTO {
  packageName: string | null = null;
  resourceName: string | null = null;
  methodName: string | null = null;
  apiPath: string | null = null;
  static override get _properties(): string[] {
    return ['packageName', 'resourceName', 'methodName', 'apiPath', '_checkOwner', '_type'];
  }
}
export class Result {
  status: number | null = null;
  error: string | null = null;
  errorCode: number | null = null;
  success: boolean | null = null;
  message: string | null = null;
  data: any | null = null;
  pagination: Pagination | null = null;
  _type: string | null = null;
  static get _properties(): string[] {
    return ['status', 'error', 'errorCode', 'success', 'message', 'data', 'pagination', '_type'];
  }
}
export class MultipartFormDataInput {}
export class ModifiableNamedIdentityWithIdentifierAndCreatorDTO extends ModifiableNamedIdentityWithCreatorDTO {
  identifier: string | null = null;
  static override get _properties(): string[] {
    return ['identifier', 'modifiedAt', 'modifiedBy', 'createdAt', 'createdBy', 'name', 'id', '_checkOwner', '_type'];
  }
}
export class NamedIdentityWithIdentifierDTO extends NamedIdentityDTO {
  identifier: string | null = null;
  static override get _properties(): string[] {
    return ['identifier', 'name', 'id', '_checkOwner', '_type'];
  }
}
export class RangeFieldReference extends FieldReference {
  min: any | null = null;
  max: any | null = null;
  static override get _properties(): string[] {
    return ['min', 'max', 'type', 'requires', 'order', '_checkOwner', '_type'];
  }
}
export class SelectionFieldReference extends FieldReference {
  values: DisplayableValueDTO[] | null = null;
  lookup: string | null = null;
  static override get _properties(): string[] {
    return ['values', 'lookup', 'type', 'requires', 'order', '_checkOwner', '_type'];
  }
}
